<template>
  <board :details="infoData" />
</template>

<script>
import Board from 'Board';
export default {
  name: 'BudgetInfo',
  components: {
    Board,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    evalAvailableColor() {
      return (price) =>
        price
          ? Math.sign(price) > 0
            ? 'font-weight-bold color-secondary-22'
            : 'font-weight-bold color-secondary-20'
          : 'font-weight-bold color-black';
    },
    infoData() {
      return [
        [
          {
            label: 'Presupuesto:',
            icon: 'fas fa-calculator color-secondary-6',
            data: this.formatPrice(this.value.bugdetTotalAmt),
            dataClass: 'color-black font-weight-bold',
          },
          {
            label: 'Pagado:',
            icon: 'fas fa-check-circle color-secondary-2',
            data: this.formatPrice(this.value.totalPaidAmt),
            dataClass: 'color-black',
          },
          {
            label: 'Proyectado:',
            icon: 'fas fa-chart-line color-orange',
            data: this.formatPrice(this.value.projectionTotalAmt),
            dataClass: 'color-black',
          },
          {
            label: 'Disponible:',
            icon: 'fas fa-check-circle color-green',
            data: this.formatPrice(this.value.availableTotalAmt),
            dataClass: this.evalAvailableColor(this.value.availableTotalAmt),
          },
        ],
      ];
    },
    formatPrice() {
      return (value) => this.$options.filters.price(value);
    },
  },
};
</script>
